import { Selection, SelectionMode, CommandBar, Text, DetailsHeader, DetailsList, IButtonProps, IColumn, ICommandBarItemProps, ICommandBarStyles, Icon, IDetailsListStyles, mergeStyleSets, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, DefaultButton, Link, DetailsListLayoutMode, IDetailsRowProps, ITextField, IPanelStyles, TooltipHost, TooltipOverflowMode, ITooltipHostStyles } from '@fluentui/react';
import React from 'react'
import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import abilityBuild from '../../shared/CASL/appAbility';

import { checkRoles } from '../../hoc/CheckRoles';
import fascicoliService from '../../services/fascicoli.service';
import { Fascicolo_Type, FilterEF_Operator, Protocol_State, Protocol_Type, RoleContext } from '../../shared/enums';
import { IAoo, IDateTimeField, IFascicolo, IField, IProtocol, IChoiceField, INumberField, IPaginatedDataEF_Request, IFilterEF, IUor, IQueryCriteriaEF } from '../../shared/interfaces';
import { reduxActions, RootState } from '../../store';
import CustomCommandBarButton from '../CustomFluentUI/CustomCommandBarButton/CustomCommandBarButton';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import pdfImage from '../../assets/images/pdf.svg';
import AppUtilities from '../../shared/Utilities/appUtilities';
import CustomCommandBarMenuItem from '../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';
import DynamicForm from '../DynamicForm/DynamicForm';
import protocolliFascicoliService from '../../services/protocolliFascicoli.service';
import axios from 'axios';
import { subject, Unsubscribe } from "@casl/ability";
import { toastRef } from '../Layout/Layout';


const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};

const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee', borderTop: '1px solid #eee' },
    primarySet: {
        '& .ms-OverflowSet-item:first-of-type': {
            display: 'flex', flexFlow: 'column', justifyContent: 'center', padding: '4px'
        },
    },
    secondarySet: {
        '& .ms-OverflowSet-item': {
            display: 'flex', flexFlow: 'row', justifyContent: 'center', padding: '4px'
        }
    }
};

const classNames = mergeStyleSets({
    fileIconHeaderIcon: {
        padding: 0,
        fontSize: '16px',
    },
    fileIconCell: {
        textAlign: 'center',
        selectors: {
            '&:before': {
                content: '.',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0px',
                visibility: 'hidden',
            },
        },
    },
    fileIconImg: {
        verticalAlign: 'middle',
        maxHeight: '16px',
        maxWidth: '16px',
    },
    controlWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    exampleToggle: {
        display: 'inline-block',
        marginBottom: '10px',
        marginRight: '30px',
    },
    selectionDetails: {
        marginBottom: '20px',
    },
    emptyColumn: {

    },
});

const tooltipHostStyles: Partial<ITooltipHostStyles> = {
    root: {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'

    }
};


const panelStyles: Partial<IPanelStyles> = {
    content: {
        padding: '24px 20px 0px',
        display: 'flex',
        flexFlow: 'column',
        overflow: 'hidden',
    },
    scrollableContent: {
        display: 'flex',
        flexFlow: 'column',
        overflow: 'hidden',

    }
}

const initialFields: IField[] = [
    {
        decimals: 0,
        percentage: false,
        displayName: "Numero protocollo",
        internalName: "Protocollo.NumeroProtocollo",
        sharepointType: "Number",
        controlType: "textbox",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false
    } as INumberField,
    {
        dateOnly: true,
        displayName: "Data Protocollo",
        internalName: "Protocollo.DataProtocollo",
        sharepointType: "Date",
        controlType: "calendar",
        required: false,
        readonly: false,
        disabled: false,
        internalValue: "",
        valid: false,
        touched: false,
        rangeMode: true

    } as IDateTimeField,
    {
        displayName: "Stato Protocollo",
        internalName: "Protocollo.StatoProtocollo",
        sharepointType: "Choice",
        controlType: "dropdown",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        options: [
            { key: Protocol_State.Allocato, text: "Allocato" },
            { key: Protocol_State.Annullato, text: "Annullato" },
            { key: Protocol_State.InCreazione, text: "In Creazione" },
            { key: Protocol_State.InCreazioneDaMail, text: "In Creazione da Mail" },
            { key: Protocol_State.Prenotato, text: "Prenotato" },
            { key: Protocol_State.Protocollato, text: "Protocollato" }
        ]

    } as IChoiceField,
    {
        displayName: "Tipo Protocollo",
        internalName: "Protocollo.TipoProtocollo",
        sharepointType: "Choice",
        controlType: "dropdown",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        options: [
            { key: Protocol_Type.DocumentoInEntrata, text: "Documento in Entrata" },
            { key: Protocol_Type.DocumentoInUscita, text: "Documento in Uscita" },
            { key: Protocol_Type.DocumentoInterno, text: "Documento Interno" }
        ]

    } as IChoiceField,
    {
        displayName: "Oggetto Protocollo",
        internalName: "Protocollo.OggettoProtocollo",
        sharepointType: "Text",
        controlType: "textbox",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false

    }

];

const queryString = require('query-string');

const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentUor: state.sessionReducer.currentUor,
    currentUser: state.sessionReducer.currentUser,
    allRoles: state.sessionReducer.allRoles,
    features: state.sessionReducer.features,
    arxeiaConfigurations: state.sessionReducer.arxeiaConfigurations,
    isMobile: state.sessionReducer.isMobile,
})
const mapDispatch = {
    setFascicolo: (fascicolo?: IFascicolo) => (reduxActions.appNavigationActions.setFascicolo(fascicolo)),
    unsetFascicolo: () => (reduxActions.appNavigationActions.unsetFascicolo()),
}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface ProtocolliFascicoloProps {
}

export interface ProtocolliFascicoloState {
    currentFascicolo: IFascicolo | undefined,
    searchPanelIsOpen: boolean;
    commandBarItems: ICommandBarItemProps[];
    items: (IProtocol | null)[];
    columns: IColumn[];
    searchFormFields: IField[];
    isLoadingProtocols: boolean;
    messageBarIsVisible: boolean;
    messageBarType: MessageBarType | undefined;
    messageBarText: string;
    queryCriteria: IQueryCriteriaEF;

}

type Props = ProtocolliFascicoloProps & RouteComponentProps & PropsFromRedux

class ProtocolliFascicolo extends React.Component<Props, ProtocolliFascicoloState> {
    unsubscribeFromAbility: Unsubscribe = () => { };

    cancelTokenSources = {};
    constructor(props) {
        super(props);
        this.state = {
            currentFascicolo: undefined,
            searchPanelIsOpen: false,
            commandBarItems: [],
            items: [],
            columns: [
                {
                    key: 'Protocollo',
                    name: 'Protocollo',
                    fieldName: 'NumeroProtocollo',
                    minWidth: 110,
                    maxWidth: 120,
                    isResizable: true
                },
                {
                    key: 'DataProtocollo',
                    name: 'Data protocollo',
                    fieldName: 'DataProtocollo',
                    minWidth: 110,
                    maxWidth: 110,
                    isResizable: true
                },
                {
                    key: 'StatoProtocollo',
                    name: 'Stato protocollo',
                    fieldName: 'StatoProtocollo',
                    minWidth: 110,
                    maxWidth: 120,
                    isResizable: true
                },
                {
                    key: 'TipoProtocollo',
                    name: 'Tipo protocollo',
                    fieldName: 'TipoProtocollo',
                    minWidth: 110,
                    maxWidth: 120,
                    isResizable: true
                },
                {
                    key: 'OggettoProtocollo',
                    name: 'Oggetto protocollo',
                    fieldName: 'Title',
                    minWidth: 110,
                    isResizable: true
                },
                /// Aggiungo una colonna vuota in coda alla tabella, è necessaria per consentire l'allineamneto tra
                /// l'header e i contenuti della tabella 
                {
                    key: 'empty',
                    name: 'empty',
                    fieldName: 'empty',
                    isIconOnly: true,

                    className: classNames.emptyColumn,
                    headerClassName: classNames.emptyColumn,
                    minWidth: 1,
                    maxWidth: 1,
                    onRender: (item) => {

                    },
                },

            ],
            searchFormFields: [...initialFields],
            isLoadingProtocols: true,
            messageBarIsVisible: false,
            messageBarType: undefined,
            messageBarText: "",
            queryCriteria: { pageNumber: 1, pageSize: 100, filters: [], sorts: [] },

        }
    }

    componentDidMount() {
        this.unsubscribeFromAbility = abilityBuild.on('updated', () => {
            this.updateCommandBarItems();


            if (this.props.currentAoo) {
                let { currentAoo, history } = this.props;
                const parsedQueryString = queryString.parse(this.props.location.search);
                let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

                if (uorId === undefined) {
                    history.push({ pathname: '/notfound' });
                }
                let fascicoloId = Number(this.props.match.params['fascicoloId']);

                let fascicoloCheckRuolo: Partial<IFascicolo> = { uorId: uorId };

                if (abilityBuild.can('read', subject('IFascicolo', fascicoloCheckRuolo))) {
                    if (currentAoo && fascicoloId) {
                        this.updateCommandBarItems();
                        this.getFascicolo();
                        this.getProtocolliDelFascicolo();
                    }
                }
                else {
                    history.push({ pathname: '/unauthorized' });
                }


            }
        });

    }
    componentDidUpdate(oldProps: Props, oldState: ProtocolliFascicoloState) {
        if ((this.props.currentAoo && this.props.features && (this.props.currentAoo !== oldProps.currentAoo || this.props.location !== oldProps.location))) {

            let { currentAoo, history } = this.props;

            const parsedQueryString = queryString.parse(this.props.location.search);
            let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;
            if (uorId === undefined) {
                history.push({ pathname: '/notfound' });
            }
            let fascicoloId = Number(this.props.match.params['fascicoloId']);

            let fascicoloCheckRuolo: Partial<IFascicolo> = { uorId: uorId };

            if (abilityBuild.can('read', subject('IFascicolo', fascicoloCheckRuolo))) {
                if (currentAoo && fascicoloId) {
                    this.updateCommandBarItems();
                    this.getFascicolo();
                    this.getProtocolliDelFascicolo();
                }
            }
            else {
                history.push({ pathname: '/unauthorized' });
            }


        }

        if (oldState.currentFascicolo !== this.state.currentFascicolo) {
            this.props.setFascicolo(this.state.currentFascicolo);
        }

        if (oldState.queryCriteria !== this.state.queryCriteria) {
            this.updateCommandBarItems();
        }
    }

    componentWillUnmount() {
        this.unsubscribeFromAbility();
        this.props.unsetFascicolo();

    }

    // get fascicolo 
    getFascicolo() {
        let { currentAoo, history } = this.props;
        const parsedQueryString = queryString.parse(this.props.location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;
        let fascicoloId = Number(this.props.match.params['fascicoloId']);

        if (currentAoo && uorId && fascicoloId) {
            //this.setState({ showIndexesLoader: true });
            fascicoliService.getFascicolo(currentAoo.id, uorId, fascicoloId)
                .then(fascicolo => {
                    if (abilityBuild.cannot('read', subject('IFascicolo', fascicolo))) {
                        history.push({ pathname: '/unauthorized' });
                    }

                    this.setState({
                        currentFascicolo: { ...fascicolo }
                    });
                })
                .catch(error => {
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: 'Attenzione',
                            detail: 'Non è stato possibile recuperare il fascicolo',
                            life: 5000
                        });
                    }
                    this.setState({
                        currentFascicolo: undefined
                    });
                });
        }
    }

    // get protocolli fascicolo
    getProtocolliDelFascicolo() {
        let { currentAoo } = this.props;
        const parsedQueryString = queryString.parse(this.props.location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;
        let fascicoloId = Number(this.props.match.params['fascicoloId']);

        if (currentAoo && uorId && fascicoloId) {
            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[protocolliFascicoliService.getProtocolliDelFascicolo.name]?.cancel("Request annullata");
            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[protocolliFascicoliService.getProtocolliDelFascicolo.name] = axios.CancelToken.source();

            this.setState({ isLoadingProtocols: true })
            let { queryCriteria } = this.state;

            protocolliFascicoliService.getProtocolliDelFascicolo(currentAoo.id, uorId, fascicoloId, queryCriteria, this.cancelTokenSources[protocolliFascicoliService.getProtocolliDelFascicolo.name].token)
                .then(result => {
                    let currentItems = this.state.items.slice();

                    let itemsNewPage: (IProtocol | null)[] = result.data;

                    let newItemsLength = currentItems.length + itemsNewPage.length;
                    if (itemsNewPage.length > 0 && newItemsLength < result.totalCount) {
                        itemsNewPage.push(null); //aggiungo un item null così DetailsList capisce che deve chiamare il metodo onRenderMissingItem
                    }

                    this.setState({
                        messageBarIsVisible: false,
                        items: [...currentItems, ...itemsNewPage],
                        isLoadingProtocols: false
                    });

                    delete this.cancelTokenSources[protocolliFascicoliService.getProtocolliDelFascicolo.name];
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    }
                    else if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: 'Attenzione',
                            detail: 'Non è stato possibile recuperare i protocolli del fascicolo',
                            life: 5000
                        });
                    }
                    this.setState({
                        items: [],
                        isLoadingProtocols: false
                    });
                });
        }
    }

    // command bar per filtrare protocolli
    updateCommandBarItems = () => {
        let newCommandBarItems: ICommandBarItemProps[] = [];

        newCommandBarItems.push(
            {
                key: 'filtri',
                commandBarButtonAs: () => (

                    <CustomCommandBarButton
                        asDefaultButton={true}
                        text='Filtri'
                        key='Filtri'
                        iconPropsFontAwesome={{ icon: ['far', 'filter'] }}
                        onClick={this.openSearchPanel}
                    />

                )
            }
        );

        if (this.state.queryCriteria.filters.length > 0) {
            newCommandBarItems.push({
                key: 'resetFiltri',
                commandBarButtonAs: () => (
                    <CustomCommandBarButton
                        text='Reset filtri'
                        key='resetFiltri'
                        iconPropsFontAwesome={{ icon: ['fal', 'filter-slash'] }}
                        onClick={this.resetSearchFormHandler}
                    />
                )
            });
        }

        this.setState({ commandBarItems: newCommandBarItems })
    }

    // metodo per paging
    onRenderMissingItem = (index?: number | undefined, rowProps?: IDetailsRowProps | undefined): null => {

        let { items, queryCriteria } = this.state;

        let currentItems = items.slice();
        currentItems.pop();

        let currentQueryCriteria: IQueryCriteriaEF = { ...queryCriteria, pageNumber: queryCriteria.pageNumber + 1 };
        this.setState({
            items: currentItems,
            queryCriteria: currentQueryCriteria
        }, () => { this.getProtocolliDelFascicolo() })
        return null;
    };

    //metodo per aggiungere gli zeri al numero di protocollo e per le bozze
    navigate = (item?: any) => {
        //aggiunge gli zeri prima del numero
        const zeroPad = (num, places) => String(num).padStart(places, '0');
        let { currentAoo, currentUor } = this.props;
        let path;

        if (item && item.id && item.numeroProtocollo) {
            let protocolnumber = zeroPad(item.numeroProtocollo, 8) + '-' + item.annoProtocollo;

            path = `/${currentAoo?.id}/${item.protocolSpId}/${protocolnumber}`;
        }
        this.props.history.push({ pathname: path, search: this.props.location.search });

    }

    // metodo per il render del contenuto delle colonne
    onRenderItemColumn = (item?: IProtocol, index?: number | undefined, column?: IColumn) => {
        let displayValue = "-";
        let columnContent: any | undefined;
        ({ displayValue, columnContent } = this.extractDisplayValueAndColumnContent(item, column));

        return (
            <TooltipHost
                content={displayValue}
                styles={tooltipHostStyles}
                overflowMode={TooltipOverflowMode.Self}
            >
                {columnContent}
            </TooltipHost>
        );
    }

    extractDisplayValueAndColumnContent = (item, column: any) => {
        let protocol = item!.protocollo;
        let displayValue = "-";
        let columnInternalName = column?.key;
        let columnContent: any = displayValue;

        if (column) {
            switch (columnInternalName) {
                case 'Protocollo':
                    displayValue = AppUtilities.FormatProtocolNumber(protocol);
                    break;
                case 'DataProtocollo':
                    displayValue = AppUtilities.FormatDate(protocol?.dataProtocollo, true);
                    break;
                case 'StatoProtocollo':
                    displayValue = protocol === null || protocol === undefined ? "-" : AppUtilities.fixInternalValueForProtocolStateEnum(protocol.statoProtocollo);
                    break;
                case 'TipoProtocollo':
                    displayValue = protocol === null || protocol === undefined ? "-" : AppUtilities.fixInternalValueForProtocolTypeEnum(protocol.tipoProtocollo);
                    break;
                case 'OggettoProtocollo':
                    displayValue = protocol === null || protocol === undefined ? "-" : protocol.oggettoProtocollo;
                    break;
                default:
                    displayValue = "-";
                    break;
            }

            if (columnInternalName === "Protocollo") {
                columnContent = (
                    <Link id={protocol!.id!.toString()} onClick={() => this.navigate(protocol)}>{displayValue}</Link>
                );
            }
            else {
                columnContent = displayValue;
            }

        }
        return { displayValue, columnContent };
    }

    //metodo per il render dell'header di tabella
    onRenderDetailsHeader = (detailsHeaderProps) => {
        const detailsListHeadrerStyles: Partial<IDetailsListStyles> = {

            root: { boxSizing: 'content-box !important' }

        };
        return (
            <DetailsHeader
                {...detailsHeaderProps}
                styles={detailsListHeadrerStyles}
            />
        );
    }

    // handlers per panel
    openSearchPanel = (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({ searchPanelIsOpen: true })
    }

    dismissSearchPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ searchPanelIsOpen: false })
    }

    //metodo per il render nei campi dei filtri
    formInputChangedHandler = (newField: IField) => {
        const updatedFormFields: IField[] = [...this.state.searchFormFields];
        let itemIndex = updatedFormFields.findIndex(el => el.internalName === newField.internalName);
        // se l'internalValue è null setto field.touched a false così viene ignorato durante la ricerca
        if (!newField.internalValue) {
            updatedFormFields[itemIndex] = { ...newField, touched: false };
        } else {
            updatedFormFields[itemIndex] = { ...newField };
        }
        this.setState({
            searchFormFields: updatedFormFields
        });

    }

    // Click su cerca del panel laterale
    searchLateralPanelSubmit = () => {

        let { searchFormFields, queryCriteria } = this.state;

        let touchedFields: IField[] = searchFormFields.filter((el: IField) => el.touched && el.internalValue);
        let fixedFields = AppUtilities.fixFieldsValueForSearchEFSubmit([...touchedFields]);

        let currentQueryCriteria: IQueryCriteriaEF = { ...queryCriteria, pageNumber: 1, filters: [...fixedFields] };

        this.setState({
            searchPanelIsOpen: false,
            isLoadingProtocols: true,
            items: [],
            queryCriteria: currentQueryCriteria
        }, () => { this.getProtocolliDelFascicolo() })
    }

    //metodo per il render dei bottoni nel panel
    onRenderLateralPanelFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Cerca"
                    onClick={this.searchLateralPanelSubmit}

                />
                <DefaultButton
                    onClick={() => this.resetSearchFields()}
                    text="Reset filtri"
                />
            </React.Fragment>
        );
    }


    //metodi per resettare i campi dei filtri
    resetSearchFormHandler = () => {
        let { searchFormFields, queryCriteria } = this.state;

        let newSearchFields = searchFormFields.map(el => {
            return { ...el, internalValue: null, touched: false };
        });

        let currentQueryCriteria: IQueryCriteriaEF = { ...queryCriteria, pageNumber: 1, filters: [] };

        this.setState({
            searchFormFields: newSearchFields,
            isLoadingProtocols: true,
            items: [],
            queryCriteria: currentQueryCriteria

        }, () => { this.getProtocolliDelFascicolo() })

    }
    resetSearchFields = () => {
        let { searchFormFields } = this.state;

        let newSearchFields = searchFormFields.map(el => {
            return { ...el, internalValue: null, touched: false };
        });
        this.setState({
            searchFormFields: newSearchFields
        });
    }

    dismissMessageBar = () => {
        this.setState({ messageBarIsVisible: false })
    }


    render() {

        return (
            <React.Fragment>
                <div className="search-component">
                    <CircleLoader loaderClass='loader-large' loading={this.state.isLoadingProtocols} />

                    <CommandBar
                        overflowButtonProps={overflowProps}
                        items={this.state.commandBarItems}
                        styles={commandBarStyles}

                    />

                    {this.state.items.length > 0 &&

                        <DetailsList
                            className="with-empty-column"
                            items={this.state.items}
                            columns={this.state.columns}
                            onRenderItemColumn={this.onRenderItemColumn}
                            onRenderDetailsHeader={this.onRenderDetailsHeader}
                            onRenderMissingItem={this.onRenderMissingItem}
                            layoutMode={DetailsListLayoutMode.justified}
                            selectionPreservedOnEmptyClick={true}

                        />
                    }
                    {this.state.items.length === 0 &&

                        <Text block style={{ padding: 25 }}>Nessun risultato trovato.</Text>
                    }

                    <Panel
                        isLightDismiss
                        isOpen={this.state.searchPanelIsOpen}
                        type={PanelType.custom}
                        customWidth={'600px'}
                        headerText={'Filtri di ricerca'}
                        id={'searchFormPanel'}  // l'ID 'searchFormPanel' viene usato nel component INPUT per gestire il click esterno al calendario
                        onDismiss={this.dismissSearchPanel}
                        onRenderFooterContent={this.onRenderLateralPanelFooterContent}

                        closeButtonAriaLabel="Close"
                        isHiddenOnDismiss={false}
                    >
                        {this.state.messageBarIsVisible &&
                            <MessageBar
                                messageBarType={this.state.messageBarType}
                                isMultiline={false}
                                onDismiss={this.dismissMessageBar}
                                dismissButtonAriaLabel="Close">{this.state.messageBarText}</MessageBar>
                        }


                        <div className={`search-form-dialog flex flex-column position-relative`}>

                            <div className={`position-relative my-scroll-div`}>
                                <div >
                                    <DynamicForm
                                        fields={this.state.searchFormFields}
                                        onInputChangedHandler={(newField) => { this.formInputChangedHandler(newField) }}
                                    />

                                </div>

                            </div>

                        </div>
                    </Panel>


                </div>
            </React.Fragment>
        );
    }


}
export default connector(withRouter(checkRoles(ProtocolliFascicolo, RoleContext.Uor)));
